export default __webpack_public_path__ + "static/media/our-game.bf5a81a8.svg";